import * as React from 'react';
import './Menu.css';
import { ClassNames } from '../../_helpers/ClassNames';
import AppProvider, { AppContextProps } from 'src/_context/App';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import { Language, NextLanguage } from 'src/_helpers/Languages';
import * as menuMobile from './menu_mobile.svg';

export type MenuProps = {
  appContext: AppContextProps;
} & RouteComponentProps<any>;

type state = {
  open: boolean;
};

export class MenuWrapped extends React.Component<MenuProps, state> {
  constructor(props: MenuProps) {
    super(props);

    this.state = {
      open: false,
    };
  }

  componentDidUpdate() {
    document.body.classList.toggle('menu--open', this.state.open);
  }

  render() {
    const app = this.props.appContext.app;
    const { open } = this.state;

    return (
      <div className={ClassNames('menu', '', open ? 'open' : '')}>
        <div className={ClassNames('menu', 'menu-inner')}>
          <a
            className={ClassNames('menu', 'burguer')}
            onClick={() => this.setState((prev) => ({ open: !prev.open }))}
          >
            <img
              src={menuMobile}
              alt='menu icon'
              className={ClassNames('menu', 'burguer-icon', 'mobile')}
            />

            <svg
              version='1.1'
              id='burguer'
              xmlns='http://www.w3.org/2000/svg'
              x='0px'
              y='0px'
              viewBox='0 0 25 20'
            >
              <rect y='0' className='burguer-svg-bg' width='25' height='20' />
              <line
                className='burguer-svg-stroke'
                x1='0'
                y1='1'
                x2='25'
                y2='1'
              />
              <rect y='0' className='burguer-svg-bg' width='25' height='20' />
              <line
                className='burguer-svg-stroke'
                x1='0'
                y1='10'
                x2='25'
                y2='10'
              />
              <rect y='0' className='burguer-svg-bg' width='25' height='20' />
              <line
                className='burguer-svg-stroke'
                x1='0'
                y1='19'
                x2='25'
                y2='19'
              />
            </svg>
          </a>
          <a
            className={ClassNames('menu', 'close')}
            onClick={() => this.setState((prev) => ({ open: !prev.open }))}
          >
            <svg
              id='close'
              version='1.1'
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 25 20'
            >
              <g>
                <defs>
                  <rect
                    id='SVGID_1_'
                    x='2.6'
                    y='0.1'
                    width='19.9'
                    height='19.9'
                  />
                </defs>
                <clipPath id='SVGID_2_'>
                  <use style={{ overflow: 'visible' }} />
                </clipPath>
                <line
                  className='close-svg-stroke'
                  x1='3.2'
                  y1='0.7'
                  x2='21.8'
                  y2='19.3'
                />
              </g>
              <g>
                <defs>
                  <rect
                    id='SVGID_3_'
                    x='2.6'
                    y='0.1'
                    width='19.9'
                    height='19.9'
                  />
                </defs>
                <clipPath id='SVGID_4_'>
                  <use style={{ overflow: 'visible' }} />
                </clipPath>
                <line
                  className='close-svg-stroke'
                  x1='3.2'
                  y1='19.3'
                  x2='21.8'
                  y2='0.7'
                />
              </g>
            </svg>
          </a>
        </div>
        <nav
          className={ClassNames(
            'menu',
            'content',
            this.state.open ? 'show' : ''
          )}
        >
          <div className={ClassNames('menu', 'switch-lang', 'desktop')}>
            {Language !== 'fr' && <a href={`?switch-lang=fr`}>FR</a>}
            {Language !== 'en' && <a href={`?switch-lang=en`}>EN</a>}
            {Language !== 'de' && <a href={`?switch-lang=de`}>DE</a>}
          </div>
          <div className={ClassNames('menu', 'switch-lang', 'mobile')}>
            {Language !== 'fr' && <a href={`?switch-lang=fr`}>FR</a>}
            {Language !== 'en' && <a href={`?switch-lang=en`}>EN</a>}
            {Language !== 'de' && <a href={`?switch-lang=de`}>DE</a>}
          </div>
          {app &&
            app.Menus.map((menu) => (
              <div key={menu.UID} className={ClassNames('menu', 'link-outer')}>
                <Link
                  key={menu.UID}
                  className={ClassNames('menu', 'link')}
                  to={
                    menu.type === 'Home'
                      ? `/${Language}#home`
                      : `/${Language}/${menu.UID}`
                  }
                  onClick={() => this.setState(() => ({ open: false }))}
                >
                  {menu.Title}
                </Link>
              </div>
            ))}
        </nav>
      </div>
    );
  }
}

export const Menu = withRouter(AppProvider.Inject(MenuWrapped));
export default Menu;



// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.tsx